import './App.css';


import { AuthProvider } from "@contexts/AuthContext";
import { ChartProvider } from "@contexts/ChartContext";

import React from "react";

import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";
import Home from "./pages";






function App() {
    return (
        <AuthProvider>
                    <ChartProvider>
        <Router>

            <Routes>
                
                        <Route exact path="/" element={<Home />} />


            </Routes>
        </Router>
        
        </ChartProvider>
                </AuthProvider>);
}

export default App;

